<script setup>
import {computed} from 'vue';
import {RouterView, useRoute, useRouter} from 'vue-router';
import {
  IconHome,
  IconSettings,
  IconLogout,
  IconMenu2,
  IconUserFilled,
  IconCarrot,
  IconUser,
  IconList,
  IconForklift,
  IconBookDownload,
  IconBlocks,
  IconBuildingBank
} from '@tabler/icons-vue';

import {useAuthStore} from './stores/authStore.js';

const route = useRoute();
const router = useRouter();

const authStore = useAuthStore();
const showLayout = computed(() => route.meta.requiresAuth === true);

const navigate = (name, params = {}) => {
  const drawerToggle = document.getElementById('main-drawer');
  if (drawerToggle) drawerToggle.checked = false;
  router.push({name, params});
};

const handleLogout = () => {
  const drawerToggle = document.getElementById('main-drawer');
  if (drawerToggle) drawerToggle.checked = false;
  authStore.logoutUser();
  router.replace({ name: 'login' });
};

</script>

<template>
  <div class="min-h-screen bg-base-200">
    <!-- Layout avec drawer pour toutes les pages sauf login -->
    <div v-if="showLayout" class="drawer">
      <input id="main-drawer" type="checkbox" class="drawer-toggle"/>

      <!-- Contenu principal (mobile only) -->
      <div class="drawer-content">
        <main class="min-h-screen max-w-md mx-auto px-4 py-4">
          <RouterView/>
        </main>

        <!-- FAB DaisyUI pour ouvrir le drawer -->
        <label
            for="main-drawer"
            class="btn btn-primary btn-circle fixed top-6 left-3 shadow-lg drawer-button"
        >
          <IconMenu2 :size="24"/>
        </label>
      </div>

      <!-- Menu dans le drawer -->
      <div class="drawer-side">
        <label for="main-drawer" class="drawer-overlay"></label>
        <aside class="menu bg-indigo-950 text-blue-50 dark:bg-indigo-950 dark:text-blue-100 w-64 min-h-full p-4">
          <div class="flex items-center">
            <h1 class="text-3xl font-bold mb-1">2BPurchase</h1>
            <div class="badge badge-secondary ml-3 font-extrabold">FL</div>
          </div>
          <span class="text-xs text-slate-400 dark:text-slate-300 mb-6">Achats en ligne pour les entreprises</span>
          <ul class="space-y-1">
            <li>
              <button
                  @click="navigate('home')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconHome :size="24" :stroke-width="1" class="text-inherit" />
                <span>Accueil</span>
              </button>
            </li>
            <li>
              <button
                  @click="navigate('orders')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconBookDownload :size="24" :stroke-width="1" class="text-inherit" />
                <span class="text-inherit">Commandes</span>
              </button>
            </li>
<!--            <li>
              <button
                  @click="navigate('situation-report')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconAdjustmentsHorizontal :size="24" :stroke-width="1" class="text-inherit" />
                <span class="text-inherit">Point de situation</span>
              </button>
            </li>-->
            <li>
              <button
                  @click="navigate('purchase-by-product')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconCarrot :size="24" :stroke-width="1" class="text-inherit" />
                <span class="text-inherit">Achat produit</span>
              </button>
            </li>
            <li>
              <button
                  @click="navigate('purchase-by-supplier')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconUser :size="24" :stroke-width="1" class="text-inherit" />
                <span>Achat fournisseur</span>
              </button>
            </li>
<!--            <li>
              <button
                  @click="navigate('not-listed-supplier', { id: 0})"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconUserOff :size="24" :stroke-width="1" class="text-inherit" />
                <span>Achat FNR</span>
              </button>
            </li>-->
            <li>
              <button
                  @click="navigate('purchase-list')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconList :size="24" :stroke-width="1" class="text-inherit" />
                <span>Liste des achats</span>
              </button>
            </li>
            <li>
              <button
                  @click="navigate('receiving-list')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconForklift :size="24" :stroke-width="1" class="text-inherit" />
                <span>Liste des réceptions</span>
              </button>
            </li>
            <li>
              <button
                  @click="navigate('stocks')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconBlocks :size="24" :stroke-width="1" class="text-inherit" />
                <span>Stocks</span>
              </button>
            </li>
            <li>
              <button
                  @click="navigate('price-list')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconBuildingBank :size="24" :stroke-width="1" class="text-inherit" />
                <span>Mercuriale</span>
              </button>
            </li>
            <li>
              <button
                  @click="navigate('settings')"
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
           text-slate-400 hover:bg-slate-700 hover:text-slate-100
           dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
           transition-colors">
                <IconSettings :size="24" :stroke-width="1" class="text-inherit" />
                <span>Paramètres</span>
              </button>
            </li>
            <li>
              <button
                  class="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg
text-slate-400 hover:bg-slate-700 hover:text-slate-100
dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100
transition-colors mt-10"
                  @click="handleLogout">
                <IconLogout :size="24" :stroke-width="1" class="text-inherit"/>
                <span>Déconnexion</span>
              </button>
            </li>
          </ul>
          <div class="mt-auto pt-4 border-t border-slate-400 dark:border-slate-400">
            <div class="flex items-center gap-2 text-blue-400 dark:text-blue-400 mb-6">
              <IconUserFilled class="w-6 h-6 shrink-0"/>
              <span v-if="authStore.login" class="text-sm font-medium truncate">{{ authStore.login }}</span>
            </div>
          </div>
        </aside>
      </div>
    </div>

    <!-- Page de login sans drawer / FAB -->
    <div v-else class="min-h-screen flex items-center justify-center bg-base-200">
      <main class="w-full max-w-md px-4">
        <RouterView/>
      </main>
    </div>
  </div>
</template>
